TS.ns('WL');

WL.documentStateHistoryModel = new Class({
    Extends: WL.EditBase,

    createProperties: function (config) {
        var me = this;
        me.parent(config);

        if (me.CanViewGridWithColumnSelected())
            var stateTransitionList = me.getDomainProperty('grdStateTransitionCollection_Property');
        if (me.CanViewGridWithoutColumnSelected())
            var stateTransitionList = me.getDomainProperty('grdStateTransitionCollectionWithoutGcSelected_Property');

        if (stateTransitionList != null) {

            //me.ImageNumberVisible = ko.computed(function () {
            //    if (me.ShowTransitionImage())
            //        return true;
            //    return false; 
            //}); 

            stateTransitionList.on('cellBeginEdit', me.onStateTransitionListBeginEdit);
            if (me.CanViewGridWithColumnSelected()) {
                stateTransitionList.getFieldByName('gcReasons_Field').renderer = "smallWrap";
                stateTransitionList.getFieldByName('gcFreeTxt_Field').renderer = "smallWrap";
                stateTransitionList.getFieldByName('gcImageNumber_Field').renderer = "hyperlinkGrid";
            }
            if (me.CanViewGridWithoutColumnSelected()) {
                stateTransitionList.getFieldByName('gcReasons2_Field').renderer = "smallWrap";
                stateTransitionList.getFieldByName('gcFreeTxt2_Field').renderer = "smallWrap";
                stateTransitionList.getFieldByName('gcImageNumber2_Field').renderer = "hyperlinkGrid";
            }

            TS.UI.Renderers.grid.smallWrap = {
                getCellClass: function (field, dataItem) {
                    return 'wrap-text';
                }
            };

            TS.UI.Renderers.grid.hyperlinkGrid = {
                getCellClass: function (field, dataItem) {
                    return 'grid-hyperlink';
                }
            };
        }

    },

    onStateTransitionListBeginEdit: function (e) {
        var me = this,
            owner = me._Domain,
            stateTransitionList = owner.getDomainProperty('grdStateTransitionCollection_Property');

        if (owner.CanViewGridWithoutColumnSelected())
            stateTransitionList = owner.getDomainProperty('grdStateTransitionCollectionWithoutGcSelected_Property');

        if (e.fieldName == 'ImageNumber') {
            e.preventDefault();

            if (stateTransitionList.SelectedItem().ImageId() == null)
                return;

            owner.performServerCommand({
                cmd: 'OpenDocumentImage',
                submitModel: true,
                extraData: { ImageId: stateTransitionList.SelectedItem().ImageId(), ImageSiteId: stateTransitionList.SelectedItem().ImageSiteId() },
                blockUI: false
            });
        }
        else if (e.fieldName == 'Selected')
        {
            if (stateTransitionList.SelectedItem().ImageId() == null)
                e.preventDefault();
        }
        else if (owner.ReadOnly) {
            e.preventDefault();
        }
    },

});

